import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AssetModuleNavbar from "./AssetModuleNavbar";
import API_BASE_URL from "../config";

const Section = ({ title, children }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="mb-3 border">
      <div className="fw-bold p-2 border-bottom d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer", backgroundColor: "#DFE4EB" }}
        onClick={() => setOpen(!open)}>
        <span>{title}</span><span>{open ? "▾" : "▸"}</span>
      </div>
      {open && <div className="row g-3 p-3">{children}</div>}
    </div>
  );
};

const TRANSFER_TYPES = ["INTER_EMPLOYEE", "INTER_DEPT", "INTER_LOCATION", "TEMPORARY"];
const CONDITION_OPTIONS = ["NEW", "GOOD", "FAIR", "DAMAGED"];

const initialForm = {
  transferType: "INTER_EMPLOYEE",
  transferDate: new Date().toISOString().split("T")[0],
  reasonForTransfer: "",
  conditionAtTransfer: "GOOD",
  dispatchDetails: "",
};

function OtpModal({ allocationId, recipientEmail, token, onClose, onSuccess }) {
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState("");
  const [verifying, setVerifying] = useState(false);
  const [resending, setResending] = useState(false);

  const handleVerify = async () => {
    if (!otpValue.trim()) { setOtpError("Please enter the OTP."); return; }
    setVerifying(true); setOtpError("");
    try {
      const res = await fetch(`${API_BASE_URL}/api/asset-allocations/${allocationId}/verify-otp`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ otp: otpValue.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { setOtpError(data.error || "Invalid OTP."); return; }
      toast.success("Recipient acknowledged asset receipt. Transfer complete.");
      onSuccess();
    } catch { setOtpError("Verification failed. Please try again."); }
    finally { setVerifying(false); }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/asset-allocations/${allocationId}/resend-otp`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) { toast.error("Failed to resend OTP."); return; }
      toast.info("OTP resent to recipient's email.");
      setOtpValue(""); setOtpError("");
    } catch { toast.error("Failed to resend OTP."); }
    finally { setResending(false); }
  };

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1050, backdropFilter: "blur(2px)" }} />
      <div role="dialog" style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%,-50%)", zIndex: 1060, width: "min(420px,90vw)", background: "#fff", borderRadius: 12, boxShadow: "0 20px 60px rgba(0,0,0,0.25)", overflow: "hidden" }}>
        <div style={{ height: 4, background: "linear-gradient(90deg,#1e3a5f,#2d5a9e)" }} />
        <div style={{ padding: "28px 28px 24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
            <div style={{ width: 44, height: 44, borderRadius: 10, background: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🔐</div>
            <div>
              <h5 style={{ margin: 0, fontWeight: 700, fontSize: 16 }}>Acknowledge Asset Receipt</h5>
              <p style={{ margin: "3px 0 0", fontSize: 13, color: "#6b7280" }}>OTP sent to <strong>{recipientEmail || "recipient's email"}</strong></p>
            </div>
          </div>
          <div style={{ background: "#f0f4fa", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#374151", marginBottom: 20, lineHeight: 1.6 }}>
            Ask the recipient to check their email and provide the 6-digit OTP to confirm receipt of the transferred asset.
          </div>
          <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Enter OTP <span style={{ color: "#dc3545" }}>*</span></label>
          <input type="text" inputMode="numeric" maxLength={6} value={otpValue}
            onChange={e => { setOtpValue(e.target.value.replace(/\D/g, "")); setOtpError(""); }}
            onKeyDown={e => e.key === "Enter" && handleVerify()}
            placeholder="6-digit OTP" autoFocus
            style={{ width: "100%", padding: "10px 14px", fontSize: 22, fontWeight: 700, letterSpacing: 8, textAlign: "center", border: `2px solid ${otpError ? "#dc3545" : "#d1d5db"}`, borderRadius: 8, outline: "none", boxSizing: "border-box" }} />
          {otpError && <p style={{ margin: "6px 0 0", fontSize: 13, color: "#dc3545" }}>{otpError}</p>}
          <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
            <button onClick={handleVerify} disabled={verifying || otpValue.length !== 6}
              style={{ flex: 1, padding: "10px", background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: otpValue.length !== 6 ? "not-allowed" : "pointer", opacity: otpValue.length !== 6 ? 0.6 : 1 }}>
              {verifying ? "Verifying..." : "Confirm Receipt"}
            </button>
            <button onClick={onClose} style={{ padding: "10px 16px", background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 14, cursor: "pointer" }}>Skip</button>
          </div>
          <p style={{ textAlign: "center", marginTop: 14, fontSize: 13, color: "#6b7280" }}>
            Didn't receive?{" "}
            <button onClick={handleResend} disabled={resending}
              style={{ background: "none", border: "none", color: "#2d5a9e", fontWeight: 600, cursor: "pointer", padding: 0, fontSize: 13 }}>
              {resending ? "Sending..." : "Resend OTP"}
            </button>
          </p>
        </div>
      </div>
    </>
  );
}

export default function NewTransfer() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [otpModal, setOtpModal] = useState(null);

  const [allAssets, setAllAssets] = useState([]);
  const [assetSearch, setAssetSearch] = useState("");
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [showAssetDrop, setShowAssetDrop] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [fromSearch, setFromSearch] = useState("");
  const [fromEmployee, setFromEmployee] = useState(null);

  const [allEmployees, setAllEmployees] = useState([]);
  const [toSearch, setToSearch] = useState("");
  const [filteredTo, setFilteredTo] = useState([]);
  const [showToDrop, setShowToDrop] = useState(false);
  const [toEmployee, setToEmployee] = useState(null);

  useEffect(() => {
    const bl = document.createElement("link"); bl.rel = "stylesheet"; bl.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"; document.head.appendChild(bl);
    const ic = document.createElement("link"); ic.rel = "stylesheet"; ic.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"; document.head.appendChild(ic);
    return () => { bl.remove(); ic.remove(); };
  }, []);

  useEffect(() => {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    if (!token) { toast.error("You must be logged in."); navigate("/"); return; }
    // if (!roles.includes("ROLE_ADMIN")) { toast.error("Unauthorized."); navigate("/"); }
  }, [navigate, token]);

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE_URL}/api/assets?status=Allocated&size=500`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => { const l = Array.isArray(d) ? d : d.content || []; setAllAssets(l); setFilteredAssets(l); })
      .catch(() => { });
    fetch(`${API_BASE_URL}/api/employees/active`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => { const l = Array.isArray(d) ? d : d.content || []; setAllEmployees(l); setFilteredTo(l); })
      .catch(() => { });
  }, [token]);

  useEffect(() => {
    const q = assetSearch.trim().toLowerCase();
    if (!q) { setFilteredAssets(allAssets); return; }
    setFilteredAssets(allAssets.filter(a =>
      (a.assetCode || "").toLowerCase().includes(q) || (a.assetName || "").toLowerCase().includes(q) ||
      (a.serialNumber || "").toLowerCase().includes(q) || (a.brand || "").toLowerCase().includes(q)
    ));
  }, [assetSearch, allAssets]);

  useEffect(() => {
    const q = toSearch.trim().toLowerCase();
    if (!q) { setFilteredTo(allEmployees); return; }
    setFilteredTo(allEmployees.filter(emp => {
      const name = emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`.trim();
      return name.toLowerCase().includes(q) || (emp.employeeId || "").toLowerCase().includes(q);
    }));
  }, [toSearch, allEmployees]);

  const empName = e => e ? e.name || `${e.firstName || ""} ${e.lastName || ""}`.trim() : "";

  const handleSubmit = async e => {
    e.preventDefault();
    if (!selectedAsset || !toEmployee) { toast.error("Please select the asset and the recipient."); return; }
    try {
      setSubmitting(true);
      const res = await fetch(`${API_BASE_URL}/api/asset-transfers`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ assetId: selectedAsset.id, fromEmployeeId: fromEmployee?.id || null, toEmployeeId: toEmployee.id, ...formData }),
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      toast.success("Transfer recorded! OTP sent to recipient for acknowledgment.");
      setFormData(initialForm);
      setSelectedAsset(null); setFromEmployee(null); setToEmployee(null);
      setAssetSearch(""); setFromSearch(""); setToSearch("");
      if (data.allocationId) {
        setOtpModal({ allocationId: data.allocationId, recipientEmail: data.recipientEmail || "" });
      }
    } catch (err) { toast.error(err.message || "Failed to initiate transfer."); }
    finally { setSubmitting(false); }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} />
      <div className="fixed-top"><AssetModuleNavbar /></div>
      <div className="container-fluid my-4" style={{ paddingTop: "90px" }}>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="fw-bold mb-0"><i className="bi bi-arrow-left-right me-2"></i> Asset Transfer</h4>
            <div className="d-flex gap-2 mt-1 mb-1">
              <button className="btn btn-primary" type="submit" form="transfer-form" disabled={submitting}>
                {submitting ? "Submitting..." : "Save"}
              </button>
              <button className="btn btn-secondary btn-sm" type="button" onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className="text-muted mt-1" style={{ fontSize: 13 }}>Move an allocated asset from one employee to another with a complete approval trail.</div>
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate("/alltransfers")}>
              <i className="bi bi-list-ul me-1"></i> Transfer History
            </button>
          </div>
        </div>

        <form id="transfer-form" onSubmit={handleSubmit}>
          <Section title="Step 1 — Select Asset &amp; Parties">
            <div className="col-md-4">
              <label className="form-label">Asset <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="text" className="form-control"
                  placeholder="Click or type to search allocated assets..."
                  value={assetSearch}
                  onChange={e => { setAssetSearch(e.target.value); setShowAssetDrop(true); setSelectedAsset(null); }}
                  onFocus={() => setShowAssetDrop(true)}
                  onBlur={() => setTimeout(() => setShowAssetDrop(false), 150)}
                  autoComplete="off" />
                {showAssetDrop && (
                  <div className="border bg-white position-absolute w-100 shadow" style={{ zIndex: 9999, maxHeight: 250, overflowY: "auto", top: "100%" }}>
                    {filteredAssets.length === 0 ? (
                      <div className="px-3 py-2 text-muted" style={{ fontSize: 13 }}>
                        {assetSearch.trim() ? "No matching allocated assets." : "No allocated assets found."}
                      </div>
                    ) : (
                      <>
                        <div className="px-3 py-1 border-bottom" style={{ fontSize: 11, color: "#6b7280", background: "#f9fafb" }}>
                          {filteredAssets.length} asset{filteredAssets.length !== 1 ? "s" : ""}{assetSearch.trim() ? " matching" : ""}
                        </div>
                        {filteredAssets.map(a => (
                          <div key={a.id} className="px-3 py-2" style={{ cursor: "pointer", fontSize: 13 }}
                            onMouseDown={() => {
                              setSelectedAsset(a);
                              setAssetSearch(`${a.assetCode} — ${a.assetName}`);
                              setShowAssetDrop(false);
                              if (a.assignedToId) {
                                const holder = allEmployees.find(e => e.id === a.assignedToId);
                                if (holder) { setFromEmployee(holder); setFromSearch(empName(holder)); }
                                else if (a.assignedToName) { setFromEmployee(null); setFromSearch(a.assignedToName); }
                              } else { setFromEmployee(null); setFromSearch(""); }
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f5f6ff"}
                            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                            <strong>{a.assetCode}</strong> — {a.assetName}
                            <small className="text-muted ms-2">{a.brand}{a.assignedToName ? ` · ${a.assignedToName}` : ""}</small>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <label className="form-label">Current Holder (From)</label>
              <input className="form-control bg-light" readOnly value={fromSearch || "—"} placeholder="Auto-filled when asset is selected" />
            </div>

            <div className="col-md-4">
              <label className="form-label">Recipient (To) <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="text" className="form-control"
                  placeholder="Click or type to search employees..."
                  value={toSearch}
                  onChange={e => { setToSearch(e.target.value); setShowToDrop(true); setToEmployee(null); }}
                  onFocus={() => setShowToDrop(true)}
                  onBlur={() => setTimeout(() => setShowToDrop(false), 150)}
                  autoComplete="off" />
                {showToDrop && (
                  <div className="border bg-white position-absolute w-100 shadow" style={{ zIndex: 9999, maxHeight: 250, overflowY: "auto", top: "100%" }}>
                    {filteredTo.length === 0 ? (
                      <div className="px-3 py-2 text-muted" style={{ fontSize: 13 }}>
                        {toSearch.trim() ? "No matching employees." : "No active employees found."}
                      </div>
                    ) : (
                      <>
                        <div className="px-3 py-1 border-bottom" style={{ fontSize: 11, color: "#6b7280", background: "#f9fafb" }}>
                          {filteredTo.length} employee{filteredTo.length !== 1 ? "s" : ""}{toSearch.trim() ? " matching" : ""}
                        </div>
                        {filteredTo.map(emp => (
                          <div key={emp.id} className="px-3 py-2" style={{ cursor: "pointer", fontSize: 13 }}
                            onMouseDown={() => { setToEmployee(emp); setToSearch(empName(emp)); setShowToDrop(false); }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f5f6ff"}
                            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                            <strong>{empName(emp)}</strong>
                            <small className="text-muted ms-2">{emp.employeeId} · {emp.department?.name || emp.departmentName}</small>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Section>

          {(selectedAsset || fromEmployee || toEmployee) && (
            <div className="row g-2 mb-3 px-1">
              {selectedAsset && (
                <div className="col-md-4">
                  <div className="border rounded p-2" style={{ background: "#f0f4fa", fontSize: 13 }}>
                    <div style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase" }}>Selected Asset</div>
                    <strong>{selectedAsset.assetCode}</strong> — {selectedAsset.assetName}
                    <div className="text-muted">{selectedAsset.brand} · {selectedAsset.status}</div>
                  </div>
                </div>
              )}
              {fromEmployee && (
                <div className="col-md-4">
                  <div className="border rounded p-2" style={{ background: "#f0f4fa", fontSize: 13 }}>
                    <div style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase" }}>Current Holder</div>
                    <strong>{empName(fromEmployee)}</strong>
                    <div className="text-muted">{fromEmployee.employeeId}</div>
                  </div>
                </div>
              )}
              {toEmployee && (
                <div className="col-md-4">
                  <div className="border rounded p-2" style={{ background: "#f0f4fa", fontSize: 13 }}>
                    <div style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase" }}>Recipient</div>
                    <strong>{empName(toEmployee)}</strong>
                    <div className="text-muted">{toEmployee.employeeId}</div>
                  </div>
                </div>
              )}
            </div>
          )}

          <Section title="Step 2 — Transfer Details">
            <div className="col-md-3">
              <label className="form-label">Transfer Type</label>
              <select name="transferType" className="form-select" value={formData.transferType} onChange={e => setFormData(p => ({ ...p, transferType: e.target.value }))}>
                {TRANSFER_TYPES.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label">Transfer Date</label>
              <input type="date" className="form-control" value={formData.transferDate} onChange={e => setFormData(p => ({ ...p, transferDate: e.target.value }))} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Condition at Transfer</label>
              <select className="form-select" value={formData.conditionAtTransfer} onChange={e => setFormData(p => ({ ...p, conditionAtTransfer: e.target.value }))}>
                {CONDITION_OPTIONS.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="col-md-12">
              <label className="form-label">Reason for Transfer</label>
              <textarea className="form-control" rows={3} value={formData.reasonForTransfer}
                onChange={e => setFormData(p => ({ ...p, reasonForTransfer: e.target.value }))}
                placeholder="Explain the transfer requirement and any business context..." />
            </div>
            <div className="col-md-12">
              <label className="form-label">Dispatch Details</label>
              <textarea className="form-control" rows={2} value={formData.dispatchDetails}
                onChange={e => setFormData(p => ({ ...p, dispatchDetails: e.target.value }))}
                placeholder="Courier, handover note, box condition, receiving details..." />
            </div>
          </Section>

          <div className="d-flex gap-2 mt-3 mb-4">
            <button className="btn btn-primary" type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Save"}
            </button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={() => navigate(-1)}>Cancel</button>
          </div>
        </form>
      </div>

      {otpModal && (
        <OtpModal
          allocationId={otpModal.allocationId}
          recipientEmail={otpModal.recipientEmail}
          token={token}
          onClose={() => setOtpModal(null)}
          onSuccess={() => { setOtpModal(null); navigate("/alltransfers"); }}
        />
      )}
    </>
  );
}
